<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <material-card
          color="green"
          :loading="loading"
        >

          <v-banner two-line>
            <v-avatar
              slot="icon"
              color="deep-purple accent-4"
              size="40"
            >
              <v-icon
                icon="mdi-lock"
                color="white"
              >
                mdi-fingerprint
              </v-icon>
            </v-avatar>

            O sistema entrará em contato com o equipamento escolhido para que a captura da digital seja realizada.
            <p>Quando o equipamento começar a piscar o LED verde, coloque o dedo <span class="font-weight-bold">{{fingers.length > 0 ? fingers[finger_position-1].name: ''}}</span>
              no leitor até ouvir o apito. Repita o procedimento e depois aguarde.</p>
          </v-banner>
              <PersonToolbar :personId=this.$route.params.id>

              </PersonToolbar>
          <v-form
            ref="form"
          >
            <v-container class="py-0">
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    class="purple-input"
                    label="Pessoa"
                    disabled
                    :value="this.person.name"
                    @keyup.enter="handleSubmit"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="8"
                >
                  <v-select
                    v-model="finger_position"
                    label="Dedo"
                    :items="fingers"
                    :loading="loading"
                    item-text="name"
                    item-value="position"
                    single-line
                    @keyup.enter="handleSubmit"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-select
                    v-model="equipment_id"
                    label="Equipamento de Captura"
                    :items="equipments.items"
                    :loading="loading"
                    item-text="name"
                    item-value="id"
                    single-line
                    :rules="[(v)=> !!v || 'Equipamento não pode ser vazio']"

                    @keyup.enter="handleSubmit"
                  />

                </v-col>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    class="text-right"
                  >
                    <v-btn
                      class="text-right"
                      :loading="loading"
                      @click="handleSubmit()"
                    >
                      <v-icon left>
                        mdi-fingerprint
                      </v-icon>
                      CAPTURAR DIGITAL
                    </v-btn>
                  </v-col>
                </v-row>
              </v-row>
              <v-divider
                class="mx-4"
              ></v-divider>
              <data-grid
                :headers="headers"
                :items="fingerprints"
                :loading="loading"
              >
                <template v-slot:item.action="{ item }">

                  <v-btn
                    :title="'Remover '+item.name "
                    text
                    icon
                    color="red"
                    @click="remove(item)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </template>

              </data-grid>
            </v-container>
          </v-form>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    import {mapGetters, mapState} from 'vuex'

    export default {
        data() {
            return {
                finger_position: 7,
                equipment_id: null,
                person: {},
                fingerprints: [],
                headers: [
                    {text: 'Posição', value: 'finger.position'},
                    {text: 'Dedo Cadastrado', value: 'finger.name'},
                    {text: 'Remover', value: 'action'},
                ],
            }
        },
        computed: {
            ...mapState('person', ['fingers']),
            ...mapState('account', ['current_unity']),
            ...mapState('equipment', ['equipments']),
            ...mapState('app', ['loading']),
            ...mapGetters('person', ['getPerson']),
        },
        mounted() {
            this.get_fingers()
            this.get_fingerprints()
            this.get_equipments()
            this.get_person()
        },
        methods: {
            handleSubmit() {
                if (this.$refs.form.validate())
                    return this.capture()
            },
            get_person() {
                this.$store.dispatch('person/GET', {id: this.$route.params.id}).then((response) => {
                    this.person = response
                })
            },
            get_fingers() {
                this.$store.dispatch('person/GET_FINGERS')
            },
            get_equipments() {
                this.$store.dispatch('equipment/LIST', {sortBy: ['name'], sortDesc: [false]})
            },
            get_fingerprints() {
                this.$store.dispatch('person/GET_FINGERPRINTS', {
                    id: this.$route.params.id,
                }).then((response) => this.fingerprints = response)
            },
            remove(fingerprint) {
                if (confirm('Digitais removidas NÃO são automaticamente removidas dos aparelhos biométricos.'))
                    this.$store.dispatch('person/DELETE_FINGERPRINT', fingerprint).then((response)=>{
                        this.get_fingerprints()
                    })
            },
            capture() {
                const vm = this
                console.log()
                this.$store.dispatch(`person/CAPTURE`, {
                    id: this.$route.params.id,
                    position: this.finger_position,
                    payload: {
                        equipment_id: this.equipment_id,
                        unity_id: this.current_unity.id
                    }
                }).then((response) => {
                    this.get_fingerprints()
                    this.$store.commit('app/SHOW_NOTIFICATION', {
                        body: `Digital Cadastrada!`,
                        color: 'green',
                    }, {root: true})
                }).catch((e) => {
                    console.log(e)
                })
            },
        },
    }
</script>
